<template>
  <div class="bannerDam">
    <div class="bannerDam__image">
      <CImage
        :alt="alt"
        :image-mobile="imageMobile"
        :image-tablet="imageTablet"
        :image-desktop="imageDesktop"
      />
    </div>
    <div class="bannerDam__title">
      <CText
        :size="titleSize"
        :color="titleColor"
        weight="700"
      >
        <slot name="title" />
      </CText>
    </div>
    <div class="bannerDam__description">
      <CText
        :size="responsiveDescriptionSize"
        :color="descriptionColor"
        weight="400"
      >
        <slot name="text" />
      </CText>
    </div>
    <div
      class="bannerDam__buttons"
      @click="pushGTM"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import CImage from '@atoms/image/image.vue'
import CText from '@atoms/text/text.vue'
import isOutbound from '@tagging/isOutbound.js'

export default {
  name: 'banner-dam',
  components: {
    CImage,
    CText,
  },
  props: {
    alt: {
      type: String,
      default: '',
    },
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    titleSize: {
      type: String,
      default: 'md',
    },
    titleColor: {
      type: String,
      default: '#43515A',
    },
    descriptionColor: {
      type: String,
      default: '#43515A',
    },
  },
  data() {
    return {
      responsiveDescriptionSize: '',
    }
  },
  mounted() {
    this.updateDescriptionSize()
    window.addEventListener('resize', this.updateDescriptionSize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateDescriptionSize)
  },
  methods: {
    updateDescriptionSize() {
      const width = window.innerWidth
      if (width <= 1199) {
        this.responsiveDescriptionSize = 'xs'
      } else {
        this.responsiveDescriptionSize = 'md'
      }
    },
    titleContent() {
      const slot = this.$slots.title
      if (slot) {
        const slotContent = slot()
        if (slotContent.length > 0 && slotContent[0].children) {
          return slotContent[0].children
        }
      }
      return ''
    },
    textContent() {
      const slot = this.$slots.text
      if (slot) {
        const slotContent = slot()
        if (slotContent.length > 0 && slotContent[0].children) {
          return slotContent[0].children
        }
      }
      return ''
    },
    pushGTM(event) {
      const target = event.target.closest('a')

      if (target) {
        window.dataLayer.push({
          event: 'click',
          section: this.textContent() || '',
          outbound: isOutbound(target),
          label: target.innerText || target.getAttribute('aria-label') || '',
          name: this.titleContent() || ''
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.bannerDam {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  text-align: left;
  width: -webkit-fill-available;
  padding-inline: 0.1rem;

  &__image {
    margin-bottom: 1rem;
    width: 100%;

    @media screen and (min-width: 992px) {
      margin-bottom: 2.5rem;
      max-height: 26.5rem;
      overflow: hidden;
    }
  }

  &__title {
    margin-bottom: 0.5rem;

    @media screen and (min-width: 992px) {
      margin-bottom: 0.875rem;
    }
  }

  &__description {
    margin-bottom: 1.5rem;

    @media screen and (min-width: 992px) {
      margin-bottom: 2rem;
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.875rem;
  }
}
</style>
